/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/28
 */
import './index.css';
import React from 'react';
import classNames from 'classname';
import Tick from '../../../svgs/tick';

const Checkbox = ({ onClick, checked, label }) => {
  return <div onClick={onClick} className="mcycle-checkbox-wrap">
    <div className={classNames('mcycle-checkbox-min', { checked })}>
      <Tick />
    </div>
    <label className="mcycle-checkbox-label">我已查看并接受</label>
  </div>
};


export default Checkbox;



// WEBPACK FOOTER //
// ./src/components/step2/checkbox/index.js